import IconDownFromLine from '@/assets/icons/lucide/arrow-down-from-line.svg?react';
import IconUpromLine from '@/assets/icons/lucide/arrow-up-from-line.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { useMemo } from 'react';

interface Props {
  grid2d_virtual: DTO__grid2d_virtual;
  div_grid: HTMLDivElement;
  is_scroll_to_top: boolean;
}

export function GRID2D_BUTTON_scroll_to({ grid2d_virtual, div_grid, is_scroll_to_top }: Props) {
  /*
   * STATE
   */
  const count_pages = useMemo(() => {
    const total_pages = grid2d_virtual.page__index_absolute_max + 1;
    const current_page_number = grid2d_virtual.page__to_load_index_absolute + 1;

    return is_scroll_to_top ? current_page_number - 1 : total_pages - current_page_number;
  }, [grid2d_virtual.page__index_absolute_max, grid2d_virtual.page__to_load_index_absolute]);

  /*
   * EVENTS
   */
  function onClick() {
    div_grid.scrollTo({
      top: is_scroll_to_top ? 0 : grid2d_virtual.virtualizer_size,
      behavior: count_pages < CONSTANTS__client.GRID2D_VIRTUAL_SCROLL_PAGES_AMOUNT_MIN_FOR_ANIMATION_INSTANT ? 'smooth' : 'instant',
    });
  }

  /*
   * HTML
   */
  if (count_pages < CONSTANTS__client.GRID2D_VIRTUAL_SCROLL_PAGES_AMOUNT_TO_SHOW_BUTTONS) return null;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant={'no-border-on-bar'}
      iconClassNameBase="!text-component-item-foreground !size-4"
      iconClassNameHovered="!text-bar-foreground"
      className="h-[28px] w-[30px]"
      {...{ onClick }}
      Icon={is_scroll_to_top ? IconUpromLine : IconDownFromLine}
    />
  );
}
